import React, { Suspense, lazy, useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { TriggerLink } from '../../TriggerLink';
import { SizeDimensionsData } from '../types/';

const SizeDimensionsModalView = lazy(() =>
  import('./SizeDimensionsModalView').then((m) => ({ default: m.SizeDimensionsModalView }))
);

export interface SizeDimensionsProps {
  data: SizeDimensionsData;
  trigger: React.ReactNode;
}

export const SizeDimensions: React.FC<SizeDimensionsProps> = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTriggerOnClick = () => setIsModalOpen(true);

  return (
    shouldRender(props) && (
      <>
        <TriggerLink onTriggerOnClick={handleTriggerOnClick} trigger={props.trigger} />
        {isModalOpen && (
          <ErrorBoundary fallback={null} onError={() => setIsModalOpen(false)}>
            <Suspense fallback={null}>
              <SizeDimensionsModalView
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                data={props.data}
              />
            </Suspense>
          </ErrorBoundary>
        )}
      </>
    )
  );
};

export const shouldRender = (props: Partial<Pick<SizeDimensionsProps, 'data'>>): boolean => {
  return props.data?.isEnabled ?? false;
};
